<template>
    <div class="row mt-2" >
        <div class="col-12">
            <label>{{$t('LAYOUTEDITOR.chooseSiblingLayout')}}</label>
            <multiselect v-model="selected"
                         :deselect-label="$t('UI.cantRemove')"
                         track-by="id"
                         :max-height="600"
                         label="title"
                         :placeholder="$t('UI.selectOne')"
                         id="layoutRotatedSiblingPicker"
                         :preserve-search="true"
                         :options="options"
                         @select="$emit('update:layoutRotatedSibling', $event)"
                         @remove="$emit('removed')"
                         :searchable="true"
                         :allow-empty="true"></multiselect>
            <div v-if="layoutRotatedSibling">
                <p v-if="layoutRotatedSibling.id">{{$t('LAYOUTEDITOR.siblingLayoutId')}}: {{layoutRotatedSibling.id}}</p>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import Multiselect from 'vue-multiselect';

export default {
    name: 'FormatSelection',
    data () {
        return {
            selected: this.layoutRotatedSibling || {}
        };
    },
    props: {
        layoutRotatedSibling: {
            type:  Object
        },
        options: {
            type: [Object, Array]
        }
    },
    components: {
        Multiselect
    },
    watch: {
        layoutRotatedSibling: {
            handler (newVal) {
                this.selected = newVal;
            },
            immediate: true,
            deep: true
        }
    }
};

</script>

<style lang="scss" scoped>

</style>
